export const replaceSiteUrl = (content) =>
  content && typeof content === 'string'
    ? content.replace(/(http|https):\/\/(localhost:8000|anothersite.gtb.io)/gi, '')
    : '';
